import { useTranslation } from 'react-i18next';

import { CertificateNestedProperty } from 'models/certificate.model';

const useCertificateHelper = () => {
  const { t } = useTranslation();

  const defaultValue = t('certificate.notProvided');

  const getLabel = (label: string) => t(`certificate.general.${label.replace(':', '')}.label`);

  function getValueByLabel<T>(
    name: T,
    properties?: CertificateNestedProperty<T>[],
    defaultVal = ''
  ) {
    return properties?.find(({ label }) => name === label)?.value || defaultVal;
  }

  return { getLabel, getValueByLabel, defaultValue };
};

export default useCertificateHelper;
